import {makeStyles} from "@material-ui/core";
export const LProveedoresStyle = makeStyles((theme) => ({
    imgFull: {
        width: '100%',
        height: 'auto',
    },
    imgContainer:{
        width: '100%',
        maxWidth: '50px',
        height: 'auto',
    }
}));
